import { apiClient } from "./client";

export const adminInstituicoesApi = {
  listar({ busca, ativa, page = 1, pageSize = 20 } = {}) {
    const p = new URLSearchParams();
    if (busca) p.set("busca", busca);
    if (ativa != null) p.set("ativa", String(ativa));
    p.set("page", String(page));
    p.set("pageSize", String(pageSize));
    return apiClient.get(`/admin/instituicoes?${p.toString()}`);
  },
  obter(id) {
    return apiClient.get(`/admin/instituicoes/${id}`);
  },
  criar(payload) {
    return apiClient.post("/admin/instituicoes", payload);
  },
  editar(id, payload) {
    return apiClient.patch(`/admin/instituicoes/${id}`, payload);
  },
  uploadLogo(id, file) {
    const fd = new FormData();
    fd.append("file", file);
    return apiClient.upload(`/admin/instituicoes/${id}/logo`, fd);
  },
  excluir(id) {
    return apiClient.delete(`/admin/instituicoes/${id}`);
  },
};
